// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607060156/js/" + chunkId + "." + {"44":"15fc203f","225":"51bf444d","481":"ef85ad84","486":"219c2c6f","770":"adf616d8"}[chunkId] + ".0.8262033537961015.chunk.js";
};